import Vue from "vue"
import VueRouter from "vue-router"

Vue.use(VueRouter)

const routes = [
    {
        path: "/",
        name: "root",
        component: () => import("../views/ViewStart")
    },
    {
        path: "/login",
        name: "login",
        component: () => import("../views/ViewStart")
    },
    {
        path: "/dashboard",
        name: "dashboard",
        component: () => import("../views/ViewDashboard")
    },
    {
        path: "/shop",
        name: "shop",
        component: () => import("../views/ViewShop")
    },
    {
        path: "/bought-products",
        name: "boughtProducts",
        component: () => import("../views/ViewBoughtProducts")
    },
    {
        path: "/projects",
        name: "projects",
        component: () => import("../views/ViewProjects")
    },
    {
        path: "/account",
        name: "account",
        component: () => import("../views/ViewAccount")
    },
    {
        path: "/change-password",
        name: "changePassword",
        component: () => import("../views/ViewChangePassword")
    },
    {
        path: "/user",
        name: "user",
        component: () => import("../views/ViewUser")
    },
    {
        path: "/users",
        name: "users",
        component: () => import("../views/ViewUsers")
    },
    {
        path: "/creditor",
        name: "creditor",
        component: () => import("../views/ViewCreditors")
    },
    {
        path: "/goodgroups",
        name: "goodgroups",
        component: () => import("../views/ViewGoodsGroups")
    },
    {
        path: "/goods",
        name: "/goods",
        component: () => import("../views/ViewGoods")
    },
    {
        path: "/products",
        name: "products",
        component: () => import("../views/ViewProducts")
    },
    {
        path: "/downloads",
        name: "downloads",
        component: () => import("../views/ViewDocuments")
    },
    {
        path: "/invoices",
        name: "invoices",
        component: () => import("../views/ViewInvoice")
    },
    {
        path: "/accounts",
        name: "accounts",
        component: () => import("../views/ViewAccounts")
    },
    {
        path: "/dashboard-content",
        name: "dashboardContent",
        component: () => import("../views/ViewDashboardContent")
    },
    {
        path: "/serverdownloads",
        name: "serverdownloads",
        component: () => import("../views/ViewServer")
    },
    {
        path: "/fonts",
        name: "fonts",
        component: () => import("../views/ViewFonts")
    },
    {
        path: "/imagemanagement",
        name: "imagemanagement",
        component: () => import("../views/ViewImageManagement")
    },
    {
        path: "/templatemanagment",
        name: "templatemanagment",
        component: () => import("../views/ViewTemplateManagement")
    },
    {
        path: "/templateconf",
        name: "templateconf",
        component: () => import("../views/ViewTemplateConfig")
    },
    {
        path: "/manualresult",
        name: "manualresult",
        component: () => import("../views/ViewManualResult")
    },
    {
        path: "/packlists",
        name: "packlists",
        component: () => import("../views/ViewPacklist")
    },
    {
        path: "/notconfirmed",
        name: "notconfirmed",
        component: () => import("../views/ViewNotConfirmedUsers")
    },
    {
        path: "/events",
        name: "events",
        component: () => import("../views/ViewEvents")
    },
    {
        path: "/logins",
        name: "logins",
        component: () => import("../views/ViewLogins")
    },
    {
        path: "/event",
        name: "event",
        component: () => import("../views/ViewEvent")
    },
    {
        path: "/unpaidinvoices",
        name: "unpaidinvoices",
        component: () => import("../views/ViewUnpaidInvoices")
    },
    {
        path: "/projectnotification",
        name: "projectnotification",
        component: () => import("../views/ViewProjectNotification")
    },

]

const router = new VueRouter({
    routes,
    mode: process.env.NODE_ENV === 'production' ? 'abstract' : 'history',
    base: process.env.NODE_ENV === "production" ? "" : "/"
})

export default router